export default "__VITE_ASSET__b0cad444__"